export const UPDATE_FENCE_DATAS = 'updateDenceDatas'
export const UPDATE_LINE_DATAS = 'updateLineDatas'
export const UPDATE_SMART_DATAS = 'updateSmartDatas'
export const CATEGORY_LIST = 'categoryList'
export const UPDATE_STANDARD_TRACK_DATA = 'updateStandardTrackData'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js